import MasterKeyStatusModel from '../Apis/MasterKeyStatus.js'
import Controller from './Controller.js';
import Auth from "@/Apis/Auth";
import MastersDataController from './MastersDataController.js';


export default class MasterKeyStatusController extends Controller {

    constructor() {
        super(new MasterKeyStatusModel());
    }
    async verifyStep(key,master_id){
        let res = await new MastersDataController().GetAll({
            filter:
              "user_id|" +
              +Auth.USER.id +
              "&&master_id|" +
              master_id+
              "&&key|"+key,
            with: ["masterKeyStatus.user"],
        });
        if(res.length == 0 || !res[0].master_key_status.value || !res[0].master_key_status ){
            return 0;
        }
        return res[0].master_key_status.value;


    }


}